export default __webpack_public_path__ + "assets/voice-mail--mic-audio-mike-music-microphone.png";